import _objectSpread from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { TextEvent } from './TextEvent';

var debug = require('debug')('CRATE:Communication:TextManager:TitleManager');

export var TitleManager =
/*#__PURE__*/
function (_TextEvent) {
  _inherits(TitleManager, _TextEvent);

  function TitleManager(opts) {
    var _this;

    _classCallCheck(this, TitleManager);

    var EventName = opts.EventName || 'Title';
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TitleManager).call(this, _objectSpread({
      EventName: EventName
    }, opts)));
    _this._textManager = opts.TextManager;
    _this._communicationChannel = _this._document._communication._behaviors_comm;
    _this.action = _this.sendChangeTitle;
    return _this;
  }
  /**
   * [sendChangeTitle Broadcast the new title]
   * @param  {[type]} title [description]
   * @return {[type]}       [description]
   */


  _createClass(TitleManager, [{
    key: "sendChangeTitle",
    value: function sendChangeTitle(title) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      debug('Title sent ', title);
      this._document.name = title;
      var msg = {
        id: this._document.uid,
        title: title
      };

      if (!id) {
        this.broadcast(msg);
      } else {
        debug('send title in unicast');
        this.unicast(id, msg);
      }
    }
  }, {
    key: "receive",

    /**
     * [changeTitle At the reception of MTitleChanged ]
     * @param  {[type]} title [description]
     * @return {[type]}       [description]
     */
    value: function receive(msg) {
      this.emit('changeTitle', msg.title);
      this._document.name = msg.title;
    }
  }]);

  return TitleManager;
}(TextEvent);